import { Component, Input, OnInit } from '@angular/core';
import { AlertMessage } from 'src/app/template/models/alert-message.model';
import { EnrollmentDetail } from '../../models/enrollment-detail';
import { EnrollmentPaymentRedsysService } from '../../services/enrollment-payment-redsys.service';
import { EnrollmentPaymentRedsys } from '../../models/enrollment-payment-redsys.model';
import { EditionService } from 'src/app/modules/editions/services/edition.service';
import { forkJoin } from 'rxjs';
import { Edition } from 'src/app/modules/editions/models/edition.model';

@Component({
    selector: 'app-enrollment-payment-redsys',
    templateUrl: './enrollment-payment-redsys.component.html',
    styleUrls: ['./enrollment-payment-redsys.component.scss']
})
export class EnrollmentPaymentRedsysComponent implements OnInit {

    @Input() enrollment: EnrollmentDetail;

    public labels: any =
    {
        payStateLabel         : 'La reserva está pendiente de pago',
        payButtonLabel        : 'Pagar',
        loadingErrorMessage   : 'Se ha producido un error al cargar los datos de pago.',
        processingErrorMessage: 'Se ha producido un error al procesar los datos de pago. Si el problema persiste, contacte con ##edition_mail##'
    }

    public urlImageVisa      : string = 'assets/images/payment/logo-visa.svg'
    public urlImageMasterCard: string = 'assets/images/payment/logo-mastercard.svg'

    public isLoadingData: boolean = false;
    public isProcessing : boolean = false;
    public alertMessage: AlertMessage = new AlertMessage();

    public edition: Edition;

    constructor (
        private readonly editionService: EditionService,
        private readonly enrollmentPaymentRedsysService: EnrollmentPaymentRedsysService) { }

    ngOnInit (): void {

        this.initData();

    }

    private initData() {

        this.isLoadingData = true;
        forkJoin({

            editionRequest: this.editionService.getById(this.enrollment.editionId)

        }).subscribe({

            next: (requests: any) => {

                this.edition = requests.editionRequest;

            },

            error: (error: any) => {

                this.alertMessage.showDangerAlert(this.labels.loadingErrorMessage);

            }

        }).add(() => {

            this.isLoadingData = false;

        });

    }

    public sendPayment() {

        this.alertMessage.reset();
        this.isProcessing = true;

        this.enrollmentPaymentRedsysService.getRequest(this.enrollment.enrollmentCode).subscribe({

            next: (response: EnrollmentPaymentRedsys) => {

                this.enrollmentPaymentRedsysService.sendRequest(response);

            },

            error: (error: any) => {

                let contactMail = this.edition.resources.find(resource => resource.resourceId === 'mail-enrollment-replyto');
                let errorMessage = this.labels.processingErrorMessage.replace('##edition_mail##', contactMail.value);
                this.alertMessage.showDangerAlert(errorMessage);

            }

        }).add(() => {

            this.isProcessing = false;

        });

    }

}
